import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
  PRICING_PLAN,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}seller/pricingPlan`;

export type SetSellerPricingPlanCommandPayload = {
  sellerId: string;
  pricingPlan: PRICING_PLAN;
};

export const setSellerPricingPlanCommand = async ({
  sellerId,
  pricingPlan,
}: SetSellerPricingPlanCommandPayload): Promise<
  BackResponseFailure | BaseBackResponse
> => {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        sellerId,
        pricingPlan,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
